import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import ReactApexChart from "react-apexcharts";

// import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
// import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken, season_start, season_end } from "../Global";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const ProductionDashboard = () => {
  const [menu, setMenu] = useState(false);
  const [cusomerbalance, setCusomerbalance] = useState([]);
  const [dataacaliber, setDataacaliber] = useState([]);
  const [dataBoxes, setDataBoxes] = useState([]);
   let season_id = localStorage.getItem("season_id");

let season_name = localStorage.getItem("season_name");

function getStartOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay(); // Sunday = 0
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
  return new Date(d.setDate(diff));
}

function getStartOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

function getEndOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function getStartOfYear(date) {
  return new Date(date.getFullYear(), 0, 1);
}
function getEndOfYear(date) {
  return new Date(date.getFullYear(), 11, 31);
}

  const now = new Date();

  const lastYearStart = new Date(now.getFullYear() - 1, 0, 1);
  const lastYearEnd = new Date(now.getFullYear() - 1, 11, 31);



  const season_start1 = new Date(season_start);
  const season_end1 = new Date(season_end);

  const predefinedRanges = [
    {
      label: 'This Week',
      value: [getStartOfWeek(now), now],
      closeOverlay: true
    },
    {
      label: 'This Month',
      value: [getStartOfMonth(now), getEndOfMonth(now)],
      closeOverlay: true
    },
    {
      label: 'This Year',
      value: [getStartOfYear(now), getEndOfYear(now)],
      closeOverlay: true
    },
    {
      label: 'Last Year',
      value: [lastYearStart, lastYearEnd],
      closeOverlay: true
    },
    {
      label: season_name,
      value: [season_start1, season_end1],
      closeOverlay: true
    }
  ];
  const [value, setValue] = useState(predefinedRanges[4].value); // index 2 is "This Year"

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
    useEffect(() => {

          const startDate = toLocalDateString(value[0]);
    const endDate = toLocalDateString(value[1]);

    const formattedRange = {
      startDate,
      endDate,season_id
    };



        axios.post("/production-dasboard/boxes",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              if (response.data.code === 200) {
                setDataBoxes(response.data.data);
              }else{
                setTimeout(() => {
                  window.location.href = "/login";
                }, 500);
              }
            }).catch((error) => {
              console.log(error);
            });

      
      
            axios.post("/production-dasboard/calculate-daily-reports",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
          .then((response) => {
            if (response.data.code === 200) {
              setCusomerbalance(response.data.data.reports_groupby);
              
           }
          })  .catch((error) => {
            console.log(error);
          });

            axios.post("/dashboard-production/daily-production-reports/listing-groupby-caliber",formattedRange,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },} )
              .then((response) => {
               
                var all_calibers = response.data.data;
                   setDataacaliber(all_calibers);
                 
              
                    })  .catch((error) => {
                      console.log(error);
                    });

      


     
    


    }, []);

 const toLocalDateString = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
const handleDateChange2 = (item) => {
  if (!item || !Array.isArray(item) || item.length < 2) {
    console.warn("Invalid date range selected:", item);
    return;
  }

  setValue(item);

  const startDate = toLocalDateString(item[0]);
  const endDate = toLocalDateString(item[1]);

  const formattedRange = {
    startDate,
    endDate, season_id
  };

  
        axios.post("/production-dasboard/boxes",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
              if (response.data.code === 200) {
                setDataBoxes(response.data.data);
              }else{
                setTimeout(() => {
                  window.location.href = "/login";
                }, 500);
              }
            }).catch((error) => {
              console.log(error);
            });

                        
    
      
          
           axios.post("/production-dasboard/calculate-daily-reports",formattedRange,{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
          .then((response) => {
            if (response.data.code === 200) {
              setCusomerbalance(response.data.data.reports_groupby);
              
           }
          })  .catch((error) => {
            console.log(error);
          });

            axios.post("/dashboard-production/daily-production-reports/listing-groupby-caliber",formattedRange,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },} )
              .then((response) => {
                var all_calibers = response.data.data;
                   setDataacaliber(all_calibers);
              
                    })  .catch((error) => {
                      console.log(error);
                    });

    
};
   
    var sColStacked_caliber = {
  chart: {
    height: 350,
    type: "bar",
    stacked: false, // Changed from true to false
    toolbar: {
      show: false,
    },
  },
  colors: ['#709506'], // green and cream

  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%', // Added to control bar width
      dataLabels: {
        position: 'top',
      },
    },
  },
  dataLabels: {
    enabled: false, // You can set to true if you want values on bars
  },
  series: [
    {
      name: "Percentage",
      data: dataacaliber.finished || [],
    },
   
  ],
  xaxis: {
    type: "category",
    categories: dataacaliber.calibers || [],
    labels: {
      rotate: -45,
      style: {
        fontSize: "12px",
      },
    },
  },
  legend: {
    show: true,
    position: "bottom",
    horizontalAlign: "center",
    offsetY: 10,
  },
  fill: {
    opacity: 1,
  },
  yaxis: {
    labels: {
      formatter: function (val) {
        return val + " %";
      },
      style: {
        fontSize: "12px",
      },
    },
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          position: "bottom",
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
};
  const downloadpdf = () => {
  const input = document.getElementById('downloadpdf');

  html2canvas(input, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // YYYY-MM-DD
  const fileName = `Production Dashboard ${formattedDate}.pdf`;
    pdf.save(fileName);
  });
};


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
             
        <div className="content container-fluid top-dashboardfilter" >

              <div className="row" >            
                    <div className="col-md-6">
                      
                        <label><b>Select The Date Range</b></label><br/>
                        <DateRangePicker
                          value={value}
                          className="dashboard-daterange"
                          // onChange={setValue}
                            onChange={handleDateChange2}
                          placeholder="Select Date Range"
                          style={{ width: 300 }}
                          ranges={predefinedRanges}
                          showOneCalendar={false}
                        />
                        
                      </div>
                      <div className="col-md-6">
                        <div className="" style={{float:'right'}}>
                            <button onClick={downloadpdf} className="btn btn-primary me-1" >
                            Export PDF <i className="fa fa-download" />
                          </button>
                        </div> 
                    </div>

                </div>
              </div>
           
          <div className="content container-fluid" id="downloadpdf">
           
            <div className="row" >
              <div className="col-xl-3 col-sm-3 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                       <div className="col-xl-8 col-sm-8 col-8">
                          <div className="dash-widget-header" style={{paddingTop:'10px'}}>
                               <div className="dash-count">
                                <h5 className="" style={{color:'darkgray',fontWeight:'300'}}>Receptions</h5>
                                  <div className="dash-counts" style={{paddingTop:'5px'}}>
                                    <p>{dataBoxes.bl_net_weight} (KG)</p>
                                </div>
                              </div>
                            </div>
                      </div>

                      <div className="col-xl-4 col-sm-4 col-4">
                          <div className="dash-widget-header">
                              <span className="dash-widget-icon bg-site">
                                <i className="fa fa-balance-scale	"></i>
                              </span>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

               <div className="col-xl-3 col-sm-3 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                       <div className="col-xl-8 col-sm-8 col-8">
                          <div className="dash-widget-header" style={{paddingTop:'10px'}}>
                               <div className="dash-count">
                                <h5 className="" style={{color:'darkgray',fontWeight:'300'}}>Finished Products</h5>
                                  <div className="dash-counts" style={{paddingTop:'5px'}}>
                                    <p>{dataBoxes.production_final_net_weight} (KG)</p>
                                </div>
                              </div>
                            </div>
                      </div>

                      <div className="col-xl-4 col-sm-4 col-4">
                          <div className="dash-widget-header">
                              <span className="dash-widget-icon bg-site">
                                <i className="fa fa-balance-scale	"></i>
                              </span>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

               <div className="col-xl-3 col-sm-3 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                       <div className="col-xl-8 col-sm-8 col-8">
                          <div className="dash-widget-header" style={{paddingTop:'10px'}}>
                               <div className="dash-count">
                                <h5 className="" style={{color:'darkgray',fontWeight:'300'}}>Decay</h5>
                                  <div className="dash-counts" style={{paddingTop:'5px'}}>
                                    <p>{dataBoxes.production_final_decay} (KG)</p>
                                </div>
                              </div>
                            </div>
                      </div>

                      <div className="col-xl-4 col-sm-4 col-4">
                          <div className="dash-widget-header">
                              <span className="dash-widget-icon bg-site">
                                <i className="fa fa-balance-scale	"></i>
                              </span>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

               <div className="col-xl-3 col-sm-3 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                       <div className="col-xl-8 col-sm-8 col-8">
                          <div className="dash-widget-header" style={{paddingTop:'10px'}}>
                               <div className="dash-count">
                                <h5 className="" style={{color:'darkgray',fontWeight:'300'}}>Losses</h5>
                                  <div className="dash-counts" style={{paddingTop:'5px'}}>
                                    <p>{dataBoxes.losses} (KG)</p>
                                </div>
                              </div>
                            </div>
                      </div>

                      <div className="col-xl-4 col-sm-4 col-4">
                          <div className="dash-widget-header">
                              <span className="dash-widget-icon bg-site">
                                <i className="fa fa-balance-scale	"></i>
                              </span>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


           
        
            </div>
            <div className="row">
                     <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title">Calibers Analytics</h5>
                    </div>
                    <div className="card-body">
                      {/* <div id="s-col-stacked" /> */}
                      <div style={{ overflowX: 'auto', width: '100%' }}>
                          <div style={{ minWidth: '1000px' }}> {/* Adjust width as needed */}
                                  <ReactApexChart
                                    options={sColStacked_caliber}
                                    series={sColStacked_caliber.series}
                                    type="bar"
                                    height={350}
                                  />
                          </div>
                        </div>

                    </div>
                  </div>
                </div>    
              <div className="col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title"> Top 10 Calculated Daily Reports</h5>
                      </div>
                      <div className="col-auto">
                        {/* <Link to="/customer-balances" className="btn-right btn btn-sm btn-outline-primary" > View All</Link> */}
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                 

                    <div className="table-responsive">
                      <table className="table table-stripped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Shift Date</th>
                            <th>Location</th>
                            <th>Shift</th>
                            <th>Total Consumption</th>
                            <th>Small Calibers</th>
                            <th>Return Total</th>
                            <th>Decay Total</th>
                            <th>Finished Products Net Weight</th>
                            <th>Pending / Raste Pallet Net Weight</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cusomerbalance.map((item, index) => {
                           

                            return (
                              <tr key={index}>
                                 <td>
                                    <Link className="btn btn-link" to={`/production-daily-reports-groupbyfilters/${item.date}_${item.location}_${item.shift}`}>
                                      {item.date}
                                    </Link>
                                </td>
                               <td>
                                 <Link  className="btn btn-link" to={`/production-daily-reports-groupbyfilters/${item.date}_${item.location}_${item.shift}`}>
                                      {item.location_name}
                                    </Link>
                                </td>
                               <td>
                                    <Link  className="btn btn-link" to={`/production-daily-reports-groupbyfilters/${item.date}_${item.location}_${item.shift}`}>
                                      {item.shift}
                                    </Link>
                                </td>
                                
                                <td>{item.total_consumption}</td>
                                <td>{item.NumberOfSmall_calibers}</td>
                                <td>{item.return_total}</td>
                                <td>{item.decay_total}</td>
                                <td>{item.finished_products_net_weight}</td>
                                <td>{item.Pending_pallet_net_weight}</td>
                                
                               
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

     
                
                </div>
        
           
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionDashboard;
